module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/JwafVS/tc-custom/9781460362648.jpg?1725275587450",
      "alt": "This image is the cover for the book Final Stand"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Final Stand\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("For two terror-filled days, ")]), _vm._v("Las Vegas cop Sasha Mills has been on the run. Now, in a remote stretch of southwest Texas, she is compelled to take a chance in a town called Bitters."), _c('br'), _c('br'), _vm._v("But her timing couldn't be worse. As the only stranger in town, she becomes the prime suspect in an arson investigationthrusting her into a spotlight that could cost her her life."), _c('br'), _c('br'), _vm._v("Because deadly danger is in fast pursuit. An international crime ring has targeted her as one of two loose ends to tie up. They "), _c('i', [_vm._v("need")]), _vm._v(" Sasha silenced. Then tragedy strikes, and running is no longer an option for this tough lady cop."), _c('br'), _c('br'), _vm._v("It's time for payback."), _c('br'), _c('br'), _vm._v("It's time to make a final stand. For justice."), _c('br'), _c('br'), _vm._v("For family. For love.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Helen R. Myers\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Helen R. Myers is a Texan by choice, and when not writing, she's spoiling her four rescued dogs.  A avid follower of the news and student of astrology, she enjoys comparing planetary aspects with daily world events.  To decompress, she experiments with all forms of gardening and cooking with the produce she raises.  You can contact her through her website at helenr.myers.com.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0